import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatCnpj(cnpj: string): string {
  const digits = cnpj.replace(/\D/g, "");
  if (digits.length !== 14) return cnpj;
  return digits.replace(
    /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/,
    "$1.$2.$3/$4-$5",
  );
}

export function toBackendMonth(v: string): string | undefined {
  if (!v) return undefined;
  const [year, month] = v.split("-");
  return `${month}/${year}`;
}

export function parseBrNumber(v: number | string | null | undefined): number {
  if (v == null) return 0;
  if (typeof v === "number") return v;
  const normalized = v.trim().replace(/\./g, "").replace(",", ".");
  const n = Number(normalized);
  return isNaN(n) ? 0 : n;
}

export function formatPhone(phone: string): string {
  const digits = phone.replace(/\D/g, "");
  if (digits.length === 11) {
    return digits.replace(/^(\d{2})(\d{5})(\d{4})$/, "($1) $2-$3");
  }
  if (digits.length === 10) {
    return digits.replace(/^(\d{2})(\d{4})(\d{4})$/, "($1) $2-$3");
  }
  return phone;
}

export function formatCompetencia(initial: string, final: string): string {
  if (!initial || initial.trim() === "" || initial === "N/A") return "N/A";

  const startDate = new Date(initial);
  const endDate = new Date(final);

  if (!isNaN(startDate.getTime()) && !isNaN(endDate.getTime())) {
    const startMonth = String(startDate.getUTCMonth() + 1).padStart(2, "0");
    const startYear = startDate.getUTCFullYear();
    const endMonth = String(endDate.getUTCMonth() + 1).padStart(2, "0");
    const endYear = endDate.getUTCFullYear();
    return `${startMonth}/${startYear} - ${endMonth}/${endYear}`;
  }

  return initial;
}
